<template>
  <el-dialog top="0px" width="1100px" title="添加外单位用户" class="dialogWrapper" :visible.sync="_dialogVisible" :close-on-click-modal="false">
    <div class="hx-form-container box-shadow" style="margin-top: 10px">
      <el-form ref="listForm" :model="listParams" label-width="120px" inline>
        <el-form-item label="手机号：" prop="mobile">
          <el-input v-model="listParams.mobile" placeholder="请输入手机号" :maxlength="11" clearable />
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleRefresh">查询</el-button>
          <el-button size="small" @click="resetForm('listForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <hx-table-result :loading="dataLoading">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <icTableColumnIndex :pageIndex="pager.pageIndex" :pageSize="pager.pageSize" />

        <el-table-column prop="mobile" align="center" label="手机号" />
        <el-table-column prop="siteName" align="left" label="供应点" />
        <el-table-column prop="specialStatus" align="center" label="是否已添加">
          <template slot-scope="scope">
            <span v-if="scope.row.specialStatus == 2">已添加</span>
            <span v-else>未添加</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.specialStatus == 1" type="text" @click="handleAppend(scope.row)">添加该用户</el-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </el-dialog>
</template>

<script>
import Vue from "vue";

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    dialogVisible(value) {
      if (value) {
        this.handleRefresh();
      }
    },
  },

  computed: {
    _dialogVisible: {
      get() {
        return this.dialogVisible;
      },
      set(value) {
        this.$emit("update:dialogVisible", value);
      },
    },
  },

  data() {
    return {
      listParams: { mobile: "", pageIndex: 1, pageSize: 15 },
      dataLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
    };
  },

  methods: {
    handleRefresh() {
      if (!this.listParams.mobile || /^1d+{10$/g.test(this.listParams.mobile)) {
        this.$message.warning("请输入完整的手机号");
        return;
      }
      this.listParams.pageIndex = 1;
      this.loadTableData();
    },
    /**
     * 加载列表数据
     */
    async loadTableData() {
      this.dataLoading = true;
      try {
        const response = await Vue.ajaxGet(this, global.apiUrl + "/supply/special/user/search", this.listParams, "dataLoading");
        this.tableData = response || [];
        this.pager.total = this.tableData.length || 0;
        this.pager.pageSize = this.listParams.pageSize || 15;
        this.pager.pageIndex = this.listParams.pageIndex || 1;
        this.dataLoading = false;
      } catch (error) {
        this.dataLoading = false;
      }
    },

    /**
     * 切换页码
     * @param pageIndex
     */
    handleCurrentChange(pageIndex) {
      this.listParams.pageIndex = pageIndex;
      this.loadTableData();
    },

    /**
     * 切换每页显示条数
     * @param pageSize
     */
    handleSizeChange(pageSize) {
      this.listParams.pageSize = pageSize;
      this.loadTableData();
    },

    /**
     * 重置表单
     * @param formName
     */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    /**
     * 添加用户
     * @param row
     */
    async handleAppend(row) {
      try {
        await Vue.ajaxPost(this, global.apiUrl + "/supply/add/special", { id: row.id, specialStatus: 2 }, "dataLoading");
        this.$message.success("操作成功");
        this.handleClose();
        this.$emit("refresh");
      } catch (error) {
        console.error(error);
      }
    },

    /**
     * 关闭
     */
    handleClose() {
      this._dialogVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.dialogWrapper {
  :deep(.el-dialog__body) {
    padding: 0px 20px 20px;
  }
}
</style>
